export default "__VITE_ASSET__URo_RBwm__"